import React from 'react';

function PageControls({ 
  currentPage, 
  totalPages, 
  changePage, 
  isRedactionMode, 
  handleRedactStart, 
  savePDF, 
  isLoading,
  hasRedactions 
}) {
  return (
    <div className="page-controls" style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 2,
      display: 'flex',
      gap: '10px',
      backgroundColor: 'white',
      padding: '8px',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    }}>
      <button 
        onClick={() => changePage(-1)} 
        disabled={currentPage === 0}
        className="font-medium"
      >
        Previous
      </button>
      <span className="font-regular">Page {currentPage + 1} of {totalPages}</span>
      <button 
        onClick={() => changePage(1)} 
        disabled={currentPage === totalPages - 1}
        className="font-medium"
      >
        Next
      </button>
      <button 
        onClick={handleRedactStart}
        className={`redact-button ${isRedactionMode ? 'active font-medium' : 'font-medium'}`}
        style={{
          padding: '4px 12px',
          backgroundColor: isRedactionMode ? '#4285f4' : '#fff',
          color: isRedactionMode ? '#fff' : '#4285f4',
          border: '2px solid #4285f4',
          borderRadius: '4px',
          cursor: 'pointer',
          whiteSpace: 'nowrap'
        }}
      >
        {isRedactionMode ? 'Exit Redaction Mode' : 'Redact Rectangle'}
      </button>
      <button 
        onClick={savePDF} 
        disabled={isLoading || !hasRedactions}
        className="font-medium"
      >
        {isLoading ? 'Saving...' : 'Save PDF'}
      </button>
    </div>
  );
}

export default PageControls; 